import React from 'react';
import StyledSlider from "../Slider/StyledSlider";
import statDiamond from '../../assets/calculator/stat_diamond.png';
import statStanding from '../../assets/calculator/stat_standing.png';
import statButterfly from '../../assets/calculator/stat_butterfly.png';
import {AdjustValue} from "./AdjustValue";
import {useTranslation} from "react-i18next";

const StaticActivity: React.FC<any> = ({pose, time, setPose, setTime,adjustValue}) => {

  const { t } = useTranslation();

  const [timeInput, setTimeInput] = React.useState(time.toString());

  React.useEffect(() => {
    setTimeInput(time.toString());
  }, [time]);

  return (
    <div>
      <h3>{t('staticActivity.title')}</h3>
      <div style={{display: 'flex', flexDirection: 'column', gap: '20px', alignItems: 'flex-start'}}>
        <div style={{width: "100%"}}>

          <div style={{display: 'flex', justifyContent: 'space-between'}}>
            <label style={{display: 'flex', alignItems: 'center', gap: '0.5rem', padding: "20px 0 10px"}}>
              {t('staticActivity.duration')}
              <input
                type="number"
                value={timeInput}
                onChange={(e) => setTimeInput(e.target.value)}
                onBlur={() => {
                  const parsed = Number(timeInput);
                  if (!isNaN(parsed)) {
                    const clamped = Math.min(Math.max(parsed, 1), 120);
                    setTime(clamped);
                  }
                }}
                step={1}
                style={{
                  width: '54px',
                  padding: '0.25rem 0 0.25rem 0.25rem',
                  fontSize: '20px',
                  borderRadius: '4px',
                  border: '1px solid #ccc',
                }}
              /> {t('minutes')}
            </label>
            <AdjustValue adjust={adjustValue.bind(null, 'time')}/>
          </div>

          <StyledSlider
            value={time}
            onChange={(val) => setTime(val)}
            min={1}
            max={120}
            step={1}
            unit={t('minutes')}
            values={[1, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120]}
          />

          <div style={{marginTop: '40px'}}>
            <div style={{marginBottom: '8px'}}>{t('staticActivity.poses')}</div>
            <div style={{display: 'flex', gap: '40px', justifyContent: 'center'}}>
              {[
                {value: 'diamond', label: 'pose.diamond', img: statDiamond},
                {value: 'standing', label: 'pose.standing', img: statStanding},
                {value: 'other', label: 'pose.other', img: statButterfly},
              ].map(({value, label, img}) => (
                <div
                  key={value}
                  onClick={() => setPose(value as any)}
                  style={{
                    cursor: 'pointer',
                  }}
                >
                  <img src={img} alt={t(label)} width={85} height={85} style={{
                    userSelect: 'none',
                    pointerEvents: 'none',
                    padding: '1px',
                    // border: pose === value ? '2px solid #4fffa2' : '2px solid transparent',
                    boxShadow: pose === value ? '0 0 20px 6px rgba(80, 210, 150, 0.7)' : '0 0 6px rgba(0,0,0,0.15)',
                    borderRadius: '50%',
                    backgroundColor: 'white'
                  }}/>
                  <div style={{textAlign: 'center', marginTop: '4px'}}>{t(label)}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StaticActivity;
